'use strict';

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var optional = require('@bit/bit.utils.string.optional');

var npmIdRegex = /^(@([^\/@]+)\/)?([^/@]+)(@([^@/]*))?(\/(.+))?$/;
var VERSION_QUERY_PARAM = 'version';
var VERSION_PATH_PARAM = 'v';

var NpmId = function () {
  /**
   * @name constructor
   * @description initialize class to handle npmIds
   * @param {string} packageId
   * @param {string} version
   * @example const parsedBitId = new NpmId('react', '16.4.5');
  */
  function NpmId(packageId, version) {
    _classCallCheck(this, NpmId);

    var parsed = npmIdRegex.exec(packageId);

    var _parsed = _slicedToArray(parsed, 4),

    /*fullMatch*/
    registry = _parsed[2],
        packageName = _parsed[3];

    this.fullName = [packageName];
    if (registry) this.registry = registry;
    this.version = version;
  }
  /**
   * @name getFullname()
   * @param {string} separator
   */


  _createClass(NpmId, [{
    key: 'getFullname',
    value: function getFullname() {
      var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
      return this.fullName.join(separator);
    }
  }, {
    key: 'toNpmId',

    /**
     * @param {Object} [options]
     * @param {boolean} [options.includeVersion]
     */
    value: function toNpmId() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$includeRegistry = _ref.includeRegistry,
          includeRegistry = _ref$includeRegistry === undefined ? true : _ref$includeRegistry,
          _ref$includeVersion = _ref.includeVersion,
          includeVersion = _ref$includeVersion === undefined ? true : _ref$includeVersion,
          _ref$includeFilePath = _ref.includeFilePath,
          includeFilePath = _ref$includeFilePath === undefined ? false : _ref$includeFilePath;

      var version = this.version,
          registry = this.registry,
          filePath = this.filePath;
      return [optional('@', includeRegistry && registry, '/'), this.getFullname(), optional('@', includeVersion && version), optional('/', includeFilePath && filePath)].join('');
    }
    /**
     * @description convert to web path format
     */

  }, {
    key: 'toUrl',
    value: function toUrl() {
      return [optional('@', this.registry, '/'), this.getFullname()].join('');
    }
    /**
     * @name toQueryParams
     * @param {Object} [options]
     * @param {boolean} [options.withVersion] - add version to query param
     * @returns string
     */

  }, {
    key: 'toQueryParams',
    value: function toQueryParams() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$withVersion = _ref2.withVersion,
          withVersion = _ref2$withVersion === undefined ? true : _ref2$withVersion;

      var version = this.version;
      var queryParams = [withVersion && version && VERSION_QUERY_PARAM + '=' + version].filter(function (x) {
        return !!x;
      }).join('&');
      return queryParams;
    }
    /**
     * @name toPathParams
     * @param {Object} [options]
     * @param {boolean} [options.withVersion=true] - add version to query param
     * @returns string
     */

  }, {
    key: 'toPathParams',
    value: function toPathParams() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$withVersion = _ref3.withVersion,
          withVersion = _ref3$withVersion === undefined ? true : _ref3$withVersion;

      var version = this.version;
      return [withVersion && optional('~' + VERSION_PATH_PARAM + '=', version)].filter(function (x) {
        return !!x;
      }).join('/');
    }
    /**
     * @description create new instance by parsing a standard npm id
     * @param {string} rawId 
     */

  }, {
    key: 'nameSpace',
    get: function get() {
      return [];
    }
  }, {
    key: 'name',
    get: function get() {
      var fullName = this.fullName;
      return fullName[0];
    }
  }], [{
    key: 'fromNpmId',
    value: function fromNpmId(rawId) {
      if (!rawId) return undefined;
      var parsed = npmIdRegex.exec(rawId);
      if (!parsed) return undefined;

      var _parsed2 = _slicedToArray(parsed, 8),

      /*fullMatch*/
      registry = _parsed2[2],
          packageId = _parsed2[3],

      /* group 3*/
      version = _parsed2[5],

      /* group 4*/
      filePath = _parsed2[7];

      var instance = new NpmId(packageId, version);
      instance.registry = registry;
      instance.filePath = filePath;
      return instance;
    }
  }, {
    key: 'fromUrl',

    /**
     * @description create new instance by parsing a web path
     * @param {string} urlId 
     * @param {string} [queryParams]
     */
    value: function fromUrl(rawId) {
      var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!rawId) return undefined;
      var parsed = npmIdRegex.exec(rawId);

      var _parsed3 = _slicedToArray(parsed, 4),

      /*fullMatch*/
      registry = _parsed3[2],
          packageName = _parsed3[3];

      var version = queryParams.version;
      var npmId = new NpmId(packageName, version);
      if (registry) npmId.registry = registry;
      return npmId;
    }
  }]);

  return NpmId;
}();

module.exports = NpmId;